module.exports = __webpack_public_path__ + "c6ac0f34.svg";